var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRoofC(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 119,
    viewBox: "0 0 160 119",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M123.837 23.9555V15.5312H139.34V29.8515",
    stroke: "#8E9AA5",
    strokeWidth: 2,
    strokeMiterlimit: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M123.082 10.0947H140.105V15.5314H123.082V10.0947Z",
    stroke: "#8E9AA5",
    strokeWidth: 2,
    strokeMiterlimit: 2,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5742 103.44H150.836V40.2793",
    stroke: "#8E9AA5",
    strokeWidth: 2,
    strokeMiterlimit: 2,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M118.077 51.0864H139.668V88.8398H118.077V51.0864Z",
    stroke: "#8E9AA5",
    strokeWidth: 2,
    strokeMiterlimit: 2,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M94.0151 59.2471H71.0664V103.247H94.0151V59.2471Z",
    stroke: "#8E9AA5",
    strokeWidth: 2,
    strokeMiterlimit: 2,
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M151.954 40.2783H60.6289",
    stroke: "#8E9AA5",
    strokeWidth: 2,
    strokeMiterlimit: 2,
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3867 32.9962L97.9348 14.5305C98.3021 14.3902 98.6923 14.3902 99.0597 14.5305L152.517 34.8634C153.506 35.2398 154.137 36.535 153.996 37.8994C153.854 39.2638 152.983 40.2784 151.955 40.2784",
    stroke: "#8E9AA5",
    strokeWidth: 2,
    strokeMiterlimit: 2,
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M67.7099 50.9976V108.999H10.8945V50.9966",
    stroke: "#8E9AA5",
    strokeWidth: 2,
    strokeMiterlimit: 2,
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M57.3222 57.3721H21.2812V89.3727H57.3222V57.3721Z",
    stroke: "#8E9AA5",
    strokeWidth: 2,
    strokeMiterlimit: 2,
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M89.4805 81.2476H85.5799C85.2783 81.2476 85.0352 80.578 85.0352 79.7476C85.0352 78.9203 85.2783 78.2476 85.5799 78.2476H89.4805C89.7809 78.2476 90.024 78.9203 90.024 79.7476C90.024 80.578 89.7809 81.2476 89.4805 81.2476Z",
    stroke: "#8E9AA5",
    strokeWidth: 2,
    strokeMiterlimit: 2,
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M70.5543 52.5357C70.2533 52.5357 69.9479 52.4468 69.6581 52.2601L39.3005 32.595L8.94366 52.2601C7.91911 52.924 6.68654 52.35 6.19012 50.9767C5.69518 49.6044 6.12374 47.9536 7.14829 47.2897L38.4035 27.0447C38.9708 26.6772 39.6309 26.6772 40.1982 27.0447L71.4534 47.2897C72.4772 47.9536 72.9058 49.6044 72.4116 50.9767C72.0553 51.9617 71.3199 52.5357 70.5543 52.5357Z",
    stroke: "#8E9AA5",
    strokeWidth: 2,
    strokeMiterlimit: 2,
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8939 103.976H67.707V109H10.8939V103.976Z",
    stroke: "#8E9AA5",
    strokeWidth: 2,
    strokeMiterlimit: 2,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoofC);
export default __webpack_public_path__ + "static/media/roof-c.61f491711e41c3ded97920d0ea3ceb41.svg";
export { ForwardRef as ReactComponent };